export const navItems = [
  {
    title: "Home",
    path: "/admin",
  },
  {
    title: "add admin",
    path: "/adminform",
  },
  {
    title: "add package",
    path: "/adminplaces",
  },
  {
    title: "Packages",
    path: "/packages",
  },
  {
    title: "feedbacks",
    path: "/feedbacks",
  },
];

